import { combineReducers } from "redux";
import { createSelector } from "reselect";
import { getType } from "typesafe-actions";
import { RootAction, RootState } from "..";
import { addPlayer, addWatched } from "../bootstrap/actions";
import * as actions from "./actions";
import { IState } from "./types";

// State Reducer
export default combineReducers<IState, RootAction>({
  data: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(addPlayer):
        return action.payload;
      default:
        return state;
    }
  },
  loginError: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.login.failure):
        return action.payload;
      default:
        return null;
    }
  },
  loginSuccess: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.login.success):
        return action.type;
      default:
        return null;
    }
  },
  passwordChangeError: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.passwordChange.failure):
        return action.payload;
      default:
        return null;
    }
  },
  passwordResetError: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.passwordReset.failure):
        return action.payload;
      default:
        return null;
    }
  },
  passwordSetError: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.passwordSet.failure):
        return action.payload;
      default:
        return null;
    }
  },
  playerUpdateError: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.playerUpdate.failure):
        return action.payload;
      default:
        return null;
    }
  },
  registerError: (_, action: RootAction) => {
    switch (action.type) {
      case getType(actions.register.failure):
        return action.payload;
      default:
        return null;
    }
  },
  watched: (state = [], action: RootAction) => {
    switch (action.type) {
      case getType(addWatched):
        return action.payload;
      case getType(actions.addToWatched):
        return state.indexOf(action.payload) === -1
          ? [...state, action.payload]
          : state;
      case getType(actions.removeFromWatched):
        return state.filter((code) => code !== action.payload);
      default:
        return state;
    }
  },
  recoveryError: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(actions.recover.failure):
        return action.payload;
      default:
        return state;
    }
  },
  recoveryStatus: (state = null, action: RootAction) => {
    switch (action.type) {
      case getType(actions.recover.success):
        return action.payload;
      default:
        return state;
    }
  },
});

// State Selectors
export const getPlayerData = (state: RootState) => state.player.data;

export const getWatched = (state: RootState) => state.player.watched;

export const getLoginError = (state: RootState) => state.player.loginError;

export const getLoginSuccess = (state: RootState) => state.player.loginSuccess;

export const getPasswordChangeError = (state: RootState) =>
  state.player.passwordChangeError;

export const getPasswordResetError = (state: RootState) =>
  state.player.passwordResetError;

export const getPasswordSetError = (state: RootState) =>
  state.player.passwordSetError;

export const getPlayerUpdateError = (state: RootState) =>
  state.player.playerUpdateError;

export const getRegisterError = (state: RootState) =>
  state.player.registerError;

export const getRecoveryError = (state: RootState) =>
  state.player.recoveryError;

export const getRecoveryStatus = (state: RootState) =>
  state.player.recoveryStatus;

export const selectIsMyEntry = createSelector(
  [getPlayerData, (_: RootState, entryId: number) => entryId],
  (player, entryId) => player?.entry === entryId,
);
